import React, { useEffect } from 'react';
import { withTranslation } from 'react-i18next';
import clsx from 'clsx';
import moment from 'moment';
import { Replay } from '@mui/icons-material';
import QuizReportPdf from './QuizReportPdf';
import { Divider } from '@mui/material';
import makeStyles from '@mui/styles/makeStyles';
import { v4 as uuidv4 } from 'uuid';
import { TimerComponent } from './Quiz';
import { arraysMatch } from './helper';
import correctAnswerIcon from 'src/assets/images/quiz/correct.svg';
import inCorrectAnswerIcon from 'src/assets/images/quiz/incorrect.svg';
import unAnswerIcon from 'src/assets/images/quiz/unanswered.svg';
import './quiz.css';

const useStyles = makeStyles((theme) => ({
    resultPage:{
        width:'100%',
        display:'flex',
        flexDirection:'column',
        marginTop:'0px'
    },

    resultTitle:{
        fontSize:'18px',
        color:'#000000'
    },

    questionImg:{
        height:'auto',
        maxWidth:'100%',
        margin:'10px 0px'
    },

    answerBtn:{
        background: '#FAFAFA',
        color: '#000000',
        border: '1px solid #EAEAEA',
        borderRadius: '5px',
        padding: '14px 15px',
        transition: 'all 0.4s ease',
        width: '100%',
        cursor: 'pointer',
        fontSize: '16px',
        fontWeight: 400,
        marginTop:'10px',
        marginBottom:'10px',
        textAlign:'left'
    },

    correct:{
        background: '#EBF5DC !important',
        color: '#000000 !important',
        border: '1px solid #13750C !important'
    },

    notAnswered:{
        background: '#FFFCDF !important',
        color: '#000000 !important',
        border: '1px solid #D99225 !important'
    },

    inCorrect:{
        background: '#FCEEED !important',
        color: '#000000 !important',
        border: '1px solid #880808 !important'
    },

    questionCount:{
        fontSize: '16px',
        color: '#000000',
        fontWeight: 600,
        padding: '10px 10px 0px 10px',
    },

    explanationDiv:{
        display:'flex',
        flexDirection:'column',
        borderRadius:'5px',
        marginTop:'25px !important',
        padding:'10px',
        width:'calc(100% - 40px)',
        margin:'auto',
    },

    tagContainer:{
        padding:'0px 10px',
        margin:'11px 0px 25px 0px'
    },

    resultAnswer:{
        padding:'0px 10px',
        marginTop:'25px',
    },

    marL11:{
        marginLeft:'11px'
    },

    marR11:{
        marginRight:'11px'
    },

    resultanswerWrapper:{
        border:'1px solid #EAEAEA',
        borderRadius:'5px',
        marginBottom:'20px',
        paddingBottom:'10px'
    },

    incorrectExp:{
        color:'#9F483B'
    },

    unanswerExp:{
        color:'#D58610'
    },

    correctExp:{
        color:'#000000'
    },

    markTag:{
        backgroundColor:'#F3F3F3',
        padding:'7px',
        borderRadius:'5px',
        fontSize:'14px',
        color:'#6D6969',
        margin:'0px'
    },

    resultTag:{
        backgroundColor:'#FAFAFA',
        border:'1px solid #EDEDED',
        borderRadius:'5px',
        fontSize:'14px',
        color:'#000',
        height:'38px',
        minWidth:'133px',
        width:'133px',
        textAlign:'center',
        display:'flex',
        flexDirection:'column',
        alignItems:'center',
        justifyContent:'center',
        [theme.breakpoints.down('md')]: {
            marginBottom:'10px',
            minWidth:'105px',
            width:'105px',
            fontSize:'12px',
        }
    },

    questionTypeTag:{
        backgroundColor:'#CCE8F8',
        padding:'7px',
        borderRadius:'5px',
        fontSize:'14px',
        color:'#1A1A1B',
        margin:'0px 5px'
    },

    rowDiv:{
        display:'flex',
        flexDirection:'row',
        alignItems:'center'
    },

    colDiv:{
        display:'flex',
        flexDirection:'column'
    },

    smColDiv:{
        [theme.breakpoints.down('md')]: {
            flexDirection:"column"
        }
    },

    timerCustomCls:{
        [theme.breakpoints.down('md')]: {
            alignSelf:'flex-end'
        }
    },

    statusTag:{
        height:'38px',
        borderRadius:'5px',
        lineHeight:2,
        minWidth:'126px',
        width:'126px',
        textAlign:'center',
        fontSize:'18px',
        fontWeight:600
    },

    statusPassTag:{
        border: '1px solid #11B505',
        backgroundColor:'#EBF5DC',
        color:'#0C8D02',
    },

    statusFailTag:{
        border: '1px solid #9F483B',
        backgroundColor:'#FCEEED',
        color:'#C43B1F',
    }
}));


const CustomResultPage = (props) => {
    const filteredValue = 'all';
    const { t, i18n, obj, quiz, attempt,reAttemptEvent, kidName } = props;
    const isRTL = i18n.translator.language;
    const ar = "'Cairo', sans-serif";
    const en = "'Poppins', sans-serif";
    const fontFamily = isRTL === 'ar' ? ar : en;
    const classes = useStyles();
    const { minScore } = quiz || {};
    const _minScore = minScore ? Number(minScore) : 0;
    useEffect(()=> {
        moment.locale(isRTL);
    },[isRTL])

    const resultTagCls = clsx({
        [classes.resultTag]: true,
        [classes.marR11]: isRTL === 'en',
        [classes.marL11]: isRTL === 'ar',
    });

    return (
      <div className={`${classes.resultPage} react-quiz-container`}>
        {attempt < quiz?.trial ?
        <button type="button" className='attemptBtn' style={{fontFamily,marginTop:'0px'}} onClick={reAttemptEvent}>
            <Replay />
            <span style={{fontFamily,margin:'0px 5px'}}>{t('quiz.reAttempt')}</span>
        </button>
        : null}
        <div className={classes.colDiv}>
            <div className={`${classes.rowDiv} ${classes.smColDiv}`} style={{justifyContent:'space-between',alignItems:'flex-start',marginBottom:'13px'}}>
                <span style={{fontFamily}} className={classes.resultTitle}><b>{t('quiz.quizCompleted')}</b> {t('quiz.youGot',{correctQuestion:obj.numberOfCorrectAnswers,totalQuestion:obj.numberOfQuestions})}</span>
                {obj?.timeTaken ?
                <TimerComponent
                    {...{
                        finish:true,
                        timeRemaining: obj.timeTaken,
                        fontFamily,
                        isRTL,
                        customCls: classes.timerCustomCls
                    }}
                />
                : null}
            </div>
            <div className={classes.rowDiv} style={{flexWrap:'wrap'}}>
                <div className={resultTagCls}><span>{t('quiz.date')} <b>{moment().format('DD/MM/YYYY')}</b></span></div>
                <div className={resultTagCls}><span>{t('quiz.attempts')} <b>{attempt || '---'}</b></span></div>
                <div className={resultTagCls}><span>{t('quiz.score')} <b>{`${obj.correctPoints} / ${obj.totalPoints}`}</b></span></div>
                <div className={`${classes.statusTag} ${obj.correctPoints >= _minScore ? classes.statusPassTag : classes.statusFailTag}`}>{obj.correctPoints >= _minScore ? t('quiz.passed') : t('quiz.failed')}</div>
                <QuizReportPdf  
                    quizData={obj}
                    quiz={quiz}
                    attempt={attempt}
                    date={Math.floor(new Date()/1000)}
                    kidName={kidName}
                />
            </div>
        </div>
        <Divider style={{margin:'40px 0px 30px 0px'}}/>

        {<RenderQuizResultQuestions questions={obj.questions} filteredValue={filteredValue} unanswered={[]} correct={[]} incorrect={[]} userInput={obj.userInput} t={t} fontFamily={fontFamily} />}
      </div>
    )
};

export default withTranslation('common')(CustomResultPage);


const RenderQuizResultQuestions = ({questions,filteredValue,unanswered,correct,incorrect,userInput,t,fontFamily}) => {
    const classes= useStyles();
    let filteredQuestions;
    let filteredUserInput;

    if (filteredValue !== 'all') {
      let targetQuestions = unanswered;
      if (filteredValue === 'correct') {
        targetQuestions = correct;
      } else if (filteredValue === 'incorrect') {
        targetQuestions = incorrect;
      }
      filteredQuestions = questions.filter(
        (_, index) => targetQuestions.indexOf(index) !== -1,
      );
      filteredUserInput = userInput.filter(
        (_, index) => targetQuestions.indexOf(index) !== -1,
      );
    }

    return (questions).map((question, index) => {
      const userInputIndex = userInput[index];

      // Default single to avoid code breaking due to automatic version upgrade
      const answerSelectionType = question.answerSelectionType || 'single';

      const userAnwserType = question.answerSelectionType === 'single' ? 
                userInputIndex === undefined ? 'unanswered' : ( userInputIndex === Number(question.correctAnswer) ) ? 'correct' : 'incorrect' :
                question.answerSelectionType === 'multiple' ?
                userInputIndex === undefined ? 'unanswered' : (arraysMatch(userInputIndex,question.correctAnswer) ? 'correct' : 'incorrect') : ''; 

      return (
        <div className={classes.resultanswerWrapper}
        key={uuidv4()}
        >
            <div style={{fontFamily}} className={classes.questionCount}>{t('quiz.questionCount', {count: `${index+1}/${questions?.length}`})}</div>
            <div className={classes.tagContainer}>
                <span className={classes.markTag}>{t('quiz.mark',{mark:question.point})}</span>
                <span className={classes.questionTypeTag}>{answerSelectionType === 'single' ? t('quiz.quizLibaray.singleSelectionTagText') : answerSelectionType === 'multiple' ? t('quiz.quizLibaray.multipleSelectionTagText') : '' }</span>
            </div>
            <h3 style={{padding:'0px 10px',margin:'0px'}}>{question.question}</h3>	

            {question && question.questionPic && (
                <img src={question.questionPic} alt="question" className={classes.questionImg} />
            )}
            <div className={classes.resultAnswer}>
                {renderAnswerInResult(question, userInputIndex,classes)}
            </div>
            <div className={`${classes.explanationDiv}`} style={{backgroundColor: userAnwserType === 'unanswered' ? '#FFFCDF' : userAnwserType === 'incorrect' ? '#FCEEED' : '#EBF5DC'}}>
                <div style={{display:'flex',flexDirection:'row',alignItems:'center',marginBottom:'6px'}}>
                    <img src={userAnwserType === 'unanswered' ? unAnswerIcon : userAnwserType === 'incorrect' ? inCorrectAnswerIcon : correctAnswerIcon} alt="userAnwserType" style={{width:'20px',height:'20px'}} />
                    <span style={{fontFamily,margin:'4px 8px 0px 8px',color: userAnwserType === 'unanswered' ? '#D58610' : userAnwserType === 'incorrect' ? '#9F483B' : '#000000',fontSize:'16px',fontWeight:600}}>{userAnwserType === 'unanswered' ? t('quiz.notAnswered') : userAnwserType === 'incorrect' ? t('quiz.answerIncorrect') : t('quiz.answerCorrect')}</span>
                </div>  
                <span style={{fontFamily}} className={userAnwserType === 'unanswered' ? classes.unanswerExp : userAnwserType === 'incorrect' ? classes.incorrectExp : classes.correctExp}>{question?.explanation}</span>
                {question?.explanationPic ? <a style={{fontFamily,textDecoration:'underline'}} target='_blank' href={question?.explanationPic}>{t && t('groupings.attachment')}</a> : null }
            </div>
        </div>
      );
    });
};

const renderAnswerInResult = (question, userInputIndex,classes) => {
    const { answers, correctAnswer, questionType } = question;
    let { answerSelectionType } = question;
    let answerBtnCorrectClassName;
    let answerBtnIncorrectClassName;

    // Default single to avoid code breaking due to automatic version upgrade
    answerSelectionType = answerSelectionType || 'single';

    return answers.map((answer, index) => {
      if (answerSelectionType === 'single') {
        // correctAnswer - is string
        answerBtnCorrectClassName = userInputIndex === undefined ? classes.notAnswered : `${index + 1}` === correctAnswer ? classes.correct : '';
        answerBtnIncorrectClassName = userInputIndex === undefined ? '' : `${userInputIndex}` !== correctAnswer
        && `${index + 1}` === `${userInputIndex}` ? classes.inCorrect : '';

        if (userInputIndex === undefined && `${index + 1}` !== correctAnswer) {
          answerBtnIncorrectClassName = 'unanswered';
        }
      } else {
        // correctAnswer - is array of numbers
        answerBtnCorrectClassName = userInputIndex === undefined ? classes.notAnswered : correctAnswer.includes(index + 1)
          ? classes.correct
          : '';
        answerBtnIncorrectClassName = userInputIndex === undefined ? '' : !correctAnswer.includes(index + 1)
        && userInputIndex?.includes(index + 1) ? classes.inCorrect : '';

        if (userInputIndex === undefined && !correctAnswer.includes(index + 1)) {
          answerBtnIncorrectClassName = 'unanswered';
        }
      }

      return (
        <div 
        key={uuidv4()}
        >
          <button
            type="button"
            disabled
            className={`${classes.answerBtn} ${answerBtnCorrectClassName}${answerBtnIncorrectClassName}`}
          >
            {questionType === 'text' && <span>{answer}</span>}
            {questionType === 'photo' && <img src={answer} alt="answer" />}
          </button>
        </div>
      );
    });
};